"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (theme) => ({
    modalContent: {
        '& strong': {
            color: theme.indigo3
        }
    }
});
//# sourceMappingURL=confirmationModal.style.js.map